import { useState } from "react";
import { Newspaper, Plane, Building2 } from "lucide-react";
import { PageHeader, Pill } from "../components/common";
import NewsFeed from "../components/NewsFeed";
import CuratedArticles from "../components/CuratedArticles";

const TABS = [
  { key: "articles", label: "Articles", icon: <Newspaper className="w-4 h-4" /> },
  { key: "airline", label: "Airline News", icon: <Plane className="w-4 h-4 -rotate-45" /> },
  { key: "airport", label: "Airport News", icon: <Building2 className="w-4 h-4" /> },
];

const REGIONS = [
  { key: "", label: "Global" },
  { key: "usa", label: "USA" },
  { key: "europe", label: "Europe" },
  { key: "asia", label: "Asia" },
  { key: "india", label: "India" },
];

export default function Articles() {
  const [tab, setTab] = useState("articles");
  const [region, setRegion] = useState("");

  return (
    <div data-testid="articles-page">
      <PageHeader eyebrow="Newsroom" title="Aviation News"
        subtitle="Editorial features plus live airline & airport headlines aggregated from across the web — each linking back to its publisher." />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-wrap gap-1 border-b border-zinc-300 mb-8">
          {TABS.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} data-testid={`articles-tab-${t.key}`}
              className={`flex items-center gap-2 px-5 py-3 text-sm font-600 -mb-px border-b-2 transition-colors ${tab === t.key ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
              {t.icon}{t.label}
            </button>
          ))}
        </div>

        <div className="pb-16">
          {tab === "articles" && <CuratedArticles />}
          {(tab === "airline" || tab === "airport") && (
            <div>
              <div className="flex flex-wrap items-center gap-2 mb-4">
                <Pill tone="blue">Live feed</Pill>
                <span className="text-sm text-muted-foreground mr-2">Latest {tab} headlines by region</span>
                <div className="flex flex-wrap gap-1.5">
                  {REGIONS.map((r) => (
                    <button key={r.key} onClick={() => setRegion(r.key)} data-testid={`news-region-${r.key || "global"}`}
                      className={`px-3 py-1.5 text-xs font-600 border transition-colors ${region === r.key ? "bg-primary text-white border-primary" : "bg-white text-muted-foreground border-zinc-300 hover:border-primary"}`}>
                      {r.label}
                    </button>
                  ))}
                </div>
              </div>
              <NewsFeed key={`${tab}-${region}`} path={`/news?category=${tab}&region=${region}&limit=18`} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
